import { createElement } from "react";
import { uuid } from "short-uuid";
  
export function parseImg(text: string): JSX.Element[] {
  const imgRegex = /(?=<img[^>]+>)|(?<=<img[^>]+>)/g;
  const srcRegex = /src=['"]([^'"]+)['"]/i;
  const splitText = text.split(imgRegex);
  const parsedItems: JSX.Element[] = [];

  for (let i = 0; i < splitText.length; i++) {
    const match = splitText[i].match(srcRegex);

    if (match) {
      const img = createElement('img', { key: uuid(), src: match[1] });
      parsedItems.push(img);
    } else {
      const span = createElement('span', { key: uuid() }, splitText[i]);
      parsedItems.push(span);
    }
  }

  return parsedItems;
}